import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { IotAsset } from '../models/iotAssetsModel.data';


@Injectable({
  providedIn: 'root',
})
export class MapContainerService {
    private activePageSubject = new BehaviorSubject<'actia-map' | 'actia-journey'>('actia-map');
  activePage$ = this.activePageSubject.asObservable();


   // Nuovo BehaviorSubject per il veicolo selezionato
   private selectedIotAssteSubject = new BehaviorSubject<IotAsset | null>(null);
   selectedIotAsset$ = this.selectedIotAssteSubject.asObservable();ù
 // Aggiungi un BehaviorSubject per lo stato di loading
    private journeyLoadingState = new BehaviorSubject<boolean>(false);
  public journeyLoading$ = this.journeyLoadingState.asObservable();


 // Subject privato per le comunicazioni interne
  private selectedIotAssetFromMapSubject = new Subject<IotAsset>();

  // Observable pubblico a cui possono sottoscriversi altri componenti
  public selectedIotAssetFromMap$: Observable<IotAsset> = this.selectedIotAssetFromMapSubject.asObservable();

  // Metodo per impostare il veicolo selezionato dalla mappa
  setSelectedIotAssetFromMap(vehicle: IotAsset): void {
    console.log('IotAsset selezionato dalla mappa:', vehicle.plate);
    this.selectedIotAssetFromMapSubject.next(vehicle);
  }


  setActivePage(page: 'actia-map' | 'actia-journey'): void {
    this.activePageSubject.next(page);
  }

  getActivePage(): 'actia-map' | 'actia-journey' {
    return this.activePageSubject.getValue();
  }

// Nuovo metodo per impostare il veicolo selezionato
setSelectedVehicle(vehicle: IotAsset | null): void {
  this.selectedIotAssteSubject.next(vehicle);
}

// Nuovo metodo per ottenere il veicolo selezionato corrente
getSelectedVehicle(): IotAsset | null {
  return this.selectedIotAssteSubject.getValue();
}

  // Metodo per impostare lo stato di loading
  setJourneyLoading(isLoading: boolean): void {
    this.journeyLoadingState.next(isLoading);
    console.log(`Journey loading state: ${isLoading}`);
  }

  // Metodo per ottenere lo stato attuale di loading
  getJourneyLoadingState(): boolean {
    return this.journeyLoadingState.value;
  }
}
